<app-menu></app-menu>

<section class="bordo-page">
  <header class="bordo-header">
    <div>
      <p class="breadcrumbs">Helpdesk / Diario de Bordo</p>
      <h1>Diario de Bordo</h1>
      <small>Hoje, {{ headerDateLabel }}</small>
    </div>
    <div class="header-actions">
      <button mat-stroked-button color="primary" (click)="openNewEntry('EVENT')">
        Novo registro
      </button>
    </div>
  </header>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Pesquisar" [(ngModel)]="filterSearchTerm" (ngModelChange)="resetPagination()">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Filtro rapido</mat-label>
      <select matNativeControl [(ngModel)]="filterQuickKey" (ngModelChange)="resetPagination()">
        <option value="">Todos</option>
        <option *ngFor="let filter of quickFilters" [value]="filter.key">{{ filter.label }}</option>
      </select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Data inicio</mat-label>
      <input matInput type="date" [(ngModel)]="filterStartDate" (ngModelChange)="resetPagination()">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Data fim</mat-label>
      <input matInput type="date" [(ngModel)]="filterEndDate" (ngModelChange)="resetPagination()">
    </mat-form-field>
  </div>

  <div class="kpi-row">
    <article class="kpi-card" *ngFor="let kpi of kpis">
      <div class="kpi-label">{{ kpi.label }}</div>
      <div class="kpi-value">{{ kpi.value }}</div>
      <small>{{ kpi.help }}</small>
    </article>
  </div>

  <mat-tab-group class="bordo-tabs" [(selectedIndex)]="activeTab" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Todos"></mat-tab>
    <mat-tab label="Incidentes"></mat-tab>
    <mat-tab label="Reunioes"></mat-tab>
  </mat-tab-group>

  <section class="bordo-layout">
    <div class="timeline">
      <header>
        <h2>Diario de Bordo</h2>
        <div class="type-actions">
          <button mat-stroked-button (click)="openNewEntry('EVENT')"><mat-icon>add_circle_outline</mat-icon>Evento</button>
          <button mat-stroked-button (click)="openNewEntry('INCIDENT')"><mat-icon>report_problem</mat-icon>Incidente</button>
          <button mat-stroked-button (click)="openNewEntry('MEETING')"><mat-icon>groups</mat-icon>Reuniao</button>
        </div>
      </header>

      <div class="timeline-list">
        <article class="timeline-card clickable" *ngFor="let item of pagedTimelineEntries" (click)="openEditEntry(item)">
          <div class="card-header">
            <div class="type-pill" [ngClass]="item.type.toLowerCase()">
              <mat-icon>{{ typeIcon(item.type) }}</mat-icon>
              <span>{{ typeLabel(item.type) }}</span>
            </div>
            <div class="card-actions">
              <small>
                <span *ngIf="item.isDraft" class="draft-inline-label">Rascunho</span>
                {{ item.dateTimeLabel || item.time }}
              </small>
              <button mat-icon-button type="button" (click)="downloadEntryPdf(item, $event)">
                <mat-icon>picture_as_pdf</mat-icon>
              </button>
              <button mat-icon-button type="button" class="timeline-delete-button" (click)="deleteTimelineEntry(item, $event)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
          <div class="meta">
            <span *ngIf="item.isDraft" class="tag draft">Rascunho</span>
            <span *ngIf="item.tag" class="tag">{{ item.tag }}</span>
            <span *ngIf="item.area" class="tag subtle">{{ item.area }}</span>
            <span *ngIf="item.severity" class="tag sev">{{ item.severity }}</span>
            <span *ngIf="item.impact" class="tag impact">Impacto {{ item.impact }}</span>
            <span *ngIf="item.owner" class="tag owner">Dono: {{ item.owner }}</span>
            <span *ngIf="item.visibility" class="tag subtle">
              {{ item.visibility === 'PUBLIC' ? 'Publico' : 'Particular' }}
            </span>
            <span *ngIf="item.attachmentsCount" class="tag attachment">
              <mat-icon>attach_file</mat-icon>
              {{ item.attachmentsCount }} anexo{{ item.attachmentsCount > 1 ? 's' : '' }}
            </span>
          </div>
        </article>
      </div>

      <div class="timeline-pagination" *ngIf="filteredTimelineEntries.length > pageSize">
        <button mat-stroked-button type="button" (click)="previousPage()" [disabled]="currentPage === 1">
          Anterior
        </button>
        <span>Pagina {{ currentPage }} de {{ totalTimelinePages }}</span>
        <button mat-stroked-button type="button" (click)="nextPage()" [disabled]="currentPage >= totalTimelinePages">
          Proxima
        </button>
      </div>
    </div>

    <aside class="summary">
      <section class="summary-card analytics-card" *ngIf="activeTab === 1; else checkMeetingAnalytics">
        <header>
          <h3>Incidentes (ultimos {{ incidentAnalyticsDays }} dias)</h3>
          <span class="analytics-avg-pill">Media: {{ incidentDailyAverage | number: '1.1-1' }}/dia</span>
        </header>
        <div class="analytics-period-toggle">
          <button
            type="button"
            *ngFor="let days of analyticsPeriodOptions"
            [class.active]="days === incidentAnalyticsDays"
            (click)="setIncidentAnalyticsDays(days)">
            {{ days }}d
          </button>
        </div>
        <div class="analytics-chart-meta">
          <span>Total no periodo: <strong>{{ incidentTotalInWindow }}</strong></span>
          <span>{{ incidentWindowLabel }}</span>
        </div>

        <div class="analytics-chart-wrap">
          <svg class="analytics-chart-svg" [attr.viewBox]="analyticsChartViewBox" preserveAspectRatio="none">
            <g class="analytics-chart-grid">
              <line
                *ngFor="let tick of incidentYAxisTicks"
                [attr.x1]="36"
                [attr.y1]="tick.y"
                [attr.x2]="624"
                [attr.y2]="tick.y">
              </line>
              <text
                *ngFor="let tick of incidentYAxisTicks"
                [attr.x]="28"
                [attr.y]="tick.y + 3"
                text-anchor="end">
                {{ tick.value }}
              </text>
            </g>

            <line
              class="analytics-avg-line"
              [attr.x1]="36"
              [attr.y1]="incidentAverageY"
              [attr.x2]="624"
              [attr.y2]="incidentAverageY">
            </line>

            <path class="analytics-trend-line" [attr.d]="incidentTrendPath"></path>

            <g *ngFor="let point of incidentChartPoints">
              <rect
                class="analytics-bar"
                [attr.x]="point.barX"
                [attr.y]="point.barY"
                [attr.width]="point.barWidth"
                [attr.height]="point.barHeight">
                <title>{{ point.fullLabel }}: {{ point.count }} incidente(s)</title>
              </rect>

              <circle class="analytics-point" [attr.cx]="point.x" [attr.cy]="point.y" r="3.2">
                <title>{{ point.fullLabel }}: {{ point.count }} incidente(s)</title>
              </circle>

              <text
                *ngIf="point.showLabel"
                class="analytics-x-label"
                [attr.x]="point.x"
                [attr.y]="214"
                text-anchor="middle">
                {{ point.tickLabel }}
              </text>
            </g>
          </svg>
          <p class="analytics-chart-caption">Linha tracejada = media de incidentes por dia.</p>
        </div>

        <div class="analytics-monthly">
          <h4>Distribuicao por mes (janela atual)</h4>
          <div class="month-row" *ngFor="let month of incidentMonthlySeries">
            <span>{{ month.label }}</span>
            <div class="month-track"><i [style.width.%]="month.percent"></i></div>
            <strong>{{ month.count }}</strong>
          </div>
        </div>

        <div class="analytics-monthly">
          <h4>Departamentos relacionados aos incidentes</h4>
          <div class="month-row" *ngFor="let dept of incidentDepartmentSeries">
            <span class="dept-name">{{ dept.label }}</span>
            <div class="month-track"><i [style.width.%]="dept.percent"></i></div>
            <strong>{{ dept.count }}</strong>
          </div>
          <p class="analytics-empty" *ngIf="!incidentDepartmentSeries.length">Nenhum incidente no periodo selecionado.</p>
        </div>
      </section>

      <ng-template #checkMeetingAnalytics>
        <section class="summary-card analytics-card" *ngIf="activeTab === 2; else daySummaryTemplate">
          <header>
            <h3>Reunioes (ultimos {{ meetingAnalyticsDays }} dias)</h3>
            <span class="analytics-avg-pill">Media: {{ meetingDailyAverage | number: '1.1-1' }}/dia</span>
          </header>
          <div class="analytics-period-toggle">
            <button
              type="button"
              *ngFor="let days of analyticsPeriodOptions"
              [class.active]="days === meetingAnalyticsDays"
              (click)="setMeetingAnalyticsDays(days)">
              {{ days }}d
            </button>
          </div>
          <div class="analytics-chart-meta">
            <span>Total no periodo: <strong>{{ meetingTotalInWindow }}</strong></span>
            <span>{{ meetingWindowLabel }}</span>
          </div>

          <div class="analytics-chart-wrap">
            <svg class="analytics-chart-svg" [attr.viewBox]="analyticsChartViewBox" preserveAspectRatio="none">
              <g class="analytics-chart-grid">
                <line
                  *ngFor="let tick of meetingYAxisTicks"
                  [attr.x1]="36"
                  [attr.y1]="tick.y"
                  [attr.x2]="624"
                  [attr.y2]="tick.y">
                </line>
                <text
                  *ngFor="let tick of meetingYAxisTicks"
                  [attr.x]="28"
                  [attr.y]="tick.y + 3"
                  text-anchor="end">
                  {{ tick.value }}
                </text>
              </g>

              <line
                class="analytics-avg-line"
                [attr.x1]="36"
                [attr.y1]="meetingAverageY"
                [attr.x2]="624"
                [attr.y2]="meetingAverageY">
              </line>

              <path class="analytics-trend-line" [attr.d]="meetingTrendPath"></path>

              <g *ngFor="let point of meetingChartPoints">
                <rect
                  class="analytics-bar"
                  [attr.x]="point.barX"
                  [attr.y]="point.barY"
                  [attr.width]="point.barWidth"
                  [attr.height]="point.barHeight">
                  <title>{{ point.fullLabel }}: {{ point.count }} reuniao(oes)</title>
                </rect>

                <circle class="analytics-point" [attr.cx]="point.x" [attr.cy]="point.y" r="3.2">
                  <title>{{ point.fullLabel }}: {{ point.count }} reuniao(oes)</title>
                </circle>

                <text
                  *ngIf="point.showLabel"
                  class="analytics-x-label"
                  [attr.x]="point.x"
                  [attr.y]="214"
                  text-anchor="middle">
                  {{ point.tickLabel }}
                </text>
              </g>
            </svg>
            <p class="analytics-chart-caption">Linha tracejada = media de reunioes por dia.</p>
          </div>

          <div class="analytics-monthly">
            <h4>Distribuicao por mes (janela atual)</h4>
            <div class="month-row" *ngFor="let month of meetingMonthlySeries">
              <span>{{ month.label }}</span>
              <div class="month-track"><i [style.width.%]="month.percent"></i></div>
              <strong>{{ month.count }}</strong>
            </div>
          </div>

          <div class="analytics-monthly">
            <h4>Departamentos relacionados as reunioes</h4>
            <div class="month-row" *ngFor="let dept of meetingDepartmentSeries">
              <span class="dept-name">{{ dept.label }}</span>
              <div class="month-track"><i [style.width.%]="dept.percent"></i></div>
              <strong>{{ dept.count }}</strong>
            </div>
            <p class="analytics-empty" *ngIf="!meetingDepartmentSeries.length">Nenhuma reuniao no periodo selecionado.</p>
          </div>
        </section>
      </ng-template>

      <ng-template #daySummaryTemplate>
        <section class="summary-card">
          <header>
            <h3>Resumo do dia</h3>
            <button mat-icon-button><mat-icon>more_horiz</mat-icon></button>
          </header>
          <p>Principais acontecimentos e status operacional consolidado do dia.</p>
          <div class="summary-columns">
            <div>
              <strong>Destaques</strong>
              <ul>
                <li *ngFor="let highlight of dailyHighlights">{{ highlight }}</li>
              </ul>
            </div>
            <div>
              <strong>Pontos de atencao</strong>
              <ul>
                <li *ngFor="let alert of attentionPoints">{{ alert }}</li>
              </ul>
            </div>
          </div>
          <div class="summary-tags">
            <mat-chip-listbox>
              <mat-chip>Incidentes: {{ getEntryCount('INCIDENT') }}</mat-chip>
              <mat-chip>Decisoes: {{ getEntryCount('DECISION') }}</mat-chip>
              <mat-chip>Riscos: {{ riskItems.length }}</mat-chip>
            </mat-chip-listbox>
          </div>
        </section>
      </ng-template>

    </aside>
  </section>
</section>

<div class="modal-backdrop" *ngIf="showNewEntryModal" (click)="closeNewEntry()"></div>
<section class="modal-card entry-modal" *ngIf="showNewEntryModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ isEditingEntry ? 'Editar registro no Diario de Bordo' : 'Novo registro no Diario de Bordo' }}</h2>
      <small>Hoje, {{ modalDateLabel }}</small>
      <p class="draft-hint" *ngIf="!entryReadOnly">Rascunho salvo automaticamente enquanto voce edita.</p>
    </div>
    <button class="icon" type="button" (click)="closeNewEntry()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="entry-types">
    <button mat-stroked-button [class.active]="selectedEntryType === 'EVENT'" (click)="changeEntryType('EVENT')" [disabled]="isEditingEntry || entryReadOnly">
      <mat-icon>add_circle_outline</mat-icon>Evento
    </button>
    <button mat-stroked-button [class.active]="selectedEntryType === 'INCIDENT'" (click)="changeEntryType('INCIDENT')" [disabled]="isEditingEntry || entryReadOnly">
      <mat-icon>report_problem</mat-icon>Incidente
    </button>
    <button mat-stroked-button [class.active]="selectedEntryType === 'MEETING'" (click)="changeEntryType('MEETING')" [disabled]="isEditingEntry || entryReadOnly">
      <mat-icon>groups</mat-icon>Reuniao
    </button>
  </div>

  <div class="entry-grid" (input)="queueEntryDraftAutosave()" (change)="queueEntryDraftAutosave()" (keyup)="queueEntryDraftAutosave()">
    <div class="entry-main">
      <section class="panel">
        <header>
          <h3>{{ selectedEntryType === 'MEETING' ? 'Assunto' : 'Ocorrido' }}</h3>
          <div class="panel-actions">
            <span class="visibility-label">Visibilidade</span>
            <mat-slide-toggle [(ngModel)]="entryIsPublic" [disabled]="entryReadOnly">Publico</mat-slide-toggle>
            <span class="visibility-state">{{ entryIsPublic ? 'Publico' : 'Particular' }}</span>
          </div>
        </header>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ selectedEntryType === 'MEETING' ? 'Assunto *' : 'Titulo *' }}</mat-label>
          <input matInput placeholder="Ex: Erro ao autenticar usuarios" [(ngModel)]="entryForm.title" [disabled]="entryReadOnly" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ selectedEntryType === 'MEETING' ? 'Objetivo' : 'Descricao' }}</mat-label>
          <textarea matInput rows="4" placeholder="Descreva o ocorrido" [(ngModel)]="entryForm.description" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>{{ selectedEntryType === 'MEETING' ? 'Departamento *' : 'Departamento afetado *' }}</mat-label>
            <select matNativeControl [(ngModel)]="entryForm.departmentId" [disabled]="entryReadOnly" required>
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let dept of departmentOptions" [ngValue]="dept.id">{{ dept.label }}</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="selectedEntryType !== 'EVENT'">
            <mat-label>Cliente/Projeto</mat-label>
            <input matInput placeholder="Opcional" [(ngModel)]="entryForm.clientProject" [disabled]="entryReadOnly">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tags</mat-label>
          <mat-chip-grid #tagGrid aria-label="Tags">
            <mat-chip-row *ngFor="let tag of entryForm.tagsList" (removed)="removeTag(tag)">
              {{ tag }}
              <button matChipRemove aria-label="Remover tag" *ngIf="!entryReadOnly">
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip-row>
            <input
              matInput
              placeholder="#api #sev1"
              [matChipInputFor]="tagGrid"
              [matChipInputSeparatorKeyCodes]="chipSeparatorKeys"
              [matChipInputAddOnBlur]="false"
              [(ngModel)]="tagsInputValue"
              (matChipInputTokenEnd)="addTagFromInput($event)"
              (keydown.enter)="$event.preventDefault()"
              [disabled]="entryReadOnly"
            >
          </mat-chip-grid>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" *ngIf="selectedEntryType !== 'EVENT'">
          <mat-label>Links relacionados (chamados, tarefas, projetos)</mat-label>
          <input matInput placeholder="CTRL-1234, TSK-556, Projeto ABC" [(ngModel)]="entryForm.links" [disabled]="entryReadOnly">
        </mat-form-field>
      </section>

      <section class="panel" *ngIf="selectedEntryType === 'INCIDENT'">
        <header>
          <h3>Detalhes do incidente</h3>
        </header>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Criticidade *</mat-label>
            <select matNativeControl [(ngModel)]="entryForm.severity" [disabled]="entryReadOnly" required>
              <option value="BAIXA">BAIXA</option>
              <option value="MÉDIA">MÉDIA</option>
              <option value="ALTA">ALTA</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Ambiente *</mat-label>
            <select matNativeControl [(ngModel)]="entryForm.incident.environment" [disabled]="entryReadOnly" required>
              <option>Producao</option>
              <option>Homologacao</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Inicio do impacto</mat-label>
            <input matInput type="datetime-local" [(ngModel)]="impactStart" [disabled]="entryReadOnly">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fim do impacto</mat-label>
            <input matInput type="datetime-local" [(ngModel)]="impactEnd" [disabled]="entryReadOnly">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Duracao</mat-label>
            <input matInput [value]="impactDuration" placeholder="Calculada automaticamente" readonly>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Servico afetado</mat-label>
          <input matInput placeholder="API Interna" [(ngModel)]="entryForm.incident.serviceAffected" [disabled]="entryReadOnly">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Status *</mat-label>
          <select matNativeControl [(ngModel)]="entryForm.incident.status" [disabled]="entryReadOnly" required>
            <option>Em andamento</option>
            <option>Mitigado</option>
            <option>Resolvido</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Origem do incidente</mat-label>
          <select matNativeControl [(ngModel)]="entryForm.incident.origin" [disabled]="entryReadOnly">
            <option *ngFor="let origin of incidentOrigins" [value]="origin">{{ origin }}</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Causa raiz</mat-label>
          <textarea matInput rows="4" [(ngModel)]="entryForm.incident.rootCause" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Acoes tomadas / Workaround</mat-label>
          <textarea matInput rows="4" [(ngModel)]="entryForm.incident.actionsTaken" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Licoes aprendidas / Plano preventivo</mat-label>
          <textarea matInput rows="4" [(ngModel)]="entryForm.incident.lessonsLearned" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
      </section>

      <section class="panel" *ngIf="selectedEntryType === 'MEETING'">
        <header>
          <h3>Ata de reuniao</h3>
        </header>
        <div class="text-toolbar" *ngIf="!entryReadOnly">
          <button type="button" (click)="applyMeetingFormat(agendaInput, 'agenda', 'bold')" aria-label="Negrito">
            <mat-icon>format_bold</mat-icon>
          </button>
          <button type="button" (click)="applyMeetingFormat(agendaInput, 'agenda', 'italic')" aria-label="Itálico">
            <mat-icon>format_italic</mat-icon>
          </button>
          <button type="button" (click)="applyMeetingFormat(agendaInput, 'agenda', 'bullet')" aria-label="Lista">
            <mat-icon>format_list_bulleted</mat-icon>
          </button>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Pauta *</mat-label>
          <textarea #agendaInput matInput rows="6" placeholder="Itens principais da reuniao" [(ngModel)]="entryForm.meeting.agenda" [disabled]="entryReadOnly" required></textarea>
        </mat-form-field>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Inicio da reuniao</mat-label>
            <input matInput type="datetime-local" [(ngModel)]="entryForm.meeting.meetingStartAt" [disabled]="entryReadOnly">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fim da reuniao</mat-label>
            <input matInput type="datetime-local" [(ngModel)]="entryForm.meeting.meetingEndAt" [disabled]="entryReadOnly">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Participantes {{ tenantName ? '(' + tenantName + ')' : '' }} *</mat-label>
          <mat-chip-grid #participantsGrid aria-label="Participantes selecionados">
            <mat-chip-row *ngFor="let user of selectedParticipantUsers" (removed)="removeParticipant(user.id)">
              {{ participantChipLabel(user) }}
              <button matChipRemove aria-label="Remover participante" *ngIf="!entryReadOnly">
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip-row>
            <input
              matInput
              placeholder="Digite para buscar"
              [matChipInputFor]="participantsGrid"
              [matChipInputAddOnBlur]="false"
              [matAutocomplete]="participantsAuto"
              [(ngModel)]="participantsInputValue"
              #participantsInput
              (keydown.enter)="$event.preventDefault()"
              [disabled]="entryReadOnly"
              required
            >
          </mat-chip-grid>
          <mat-autocomplete #participantsAuto="matAutocomplete" (optionSelected)="selectParticipant($event.option.value)">
            <mat-option *ngIf="tenantUsersLoading" disabled>Carregando usuarios...</mat-option>
            <mat-option *ngIf="!tenantUsersLoading && !tenantUsers.length" disabled>Nenhum usuario encontrado</mat-option>
            <mat-option *ngFor="let user of filteredTenantUsers" [value]="user.id">
              {{ user.label || user.name || user.email || user.username || 'Usuario' }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Participantes externos (opcional)</mat-label>
          <mat-chip-grid #externalGrid aria-label="Participantes externos">
            <mat-chip-row *ngFor="let name of entryForm.meeting.participantsExternalList" (removed)="removeExternalParticipant(name)">
              {{ name }}
              <button matChipRemove aria-label="Remover participante" *ngIf="!entryReadOnly">
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip-row>
            <input
              matInput
              placeholder="Nome, Nome"
              [matChipInputFor]="externalGrid"
              [matChipInputSeparatorKeyCodes]="chipSeparatorKeys"
              [matChipInputAddOnBlur]="false"
              [(ngModel)]="participantsExternalInputValue"
              (matChipInputTokenEnd)="addExternalParticipant($event)"
              (keydown.enter)="$event.preventDefault()"
              [disabled]="entryReadOnly"
            >
          </mat-chip-grid>
        </mat-form-field>
        <div class="text-toolbar" *ngIf="!entryReadOnly">
          <button type="button" (click)="applyMeetingFormat(decisionsInput, 'decisions', 'bold')" aria-label="Negrito">
            <mat-icon>format_bold</mat-icon>
          </button>
          <button type="button" (click)="applyMeetingFormat(decisionsInput, 'decisions', 'italic')" aria-label="Itálico">
            <mat-icon>format_italic</mat-icon>
          </button>
          <button type="button" (click)="applyMeetingFormat(decisionsInput, 'decisions', 'bullet')" aria-label="Lista">
            <mat-icon>format_list_bulleted</mat-icon>
          </button>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Decisoes</mat-label>
          <textarea #decisionsInput matInput rows="6" placeholder="Decisoes registradas" [(ngModel)]="entryForm.meeting.decisions" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
        <div class="text-toolbar" *ngIf="!entryReadOnly">
          <button type="button" (click)="applyMeetingFormat(actionsInput, 'actions', 'bold')" aria-label="Negrito">
            <mat-icon>format_bold</mat-icon>
          </button>
          <button type="button" (click)="applyMeetingFormat(actionsInput, 'actions', 'italic')" aria-label="Itálico">
            <mat-icon>format_italic</mat-icon>
          </button>
          <button type="button" (click)="applyMeetingFormat(actionsInput, 'actions', 'bullet')" aria-label="Lista">
            <mat-icon>format_list_bulleted</mat-icon>
          </button>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Encaminhamentos</mat-label>
          <textarea #actionsInput matInput rows="6" placeholder="Acoes e responsaveis" [(ngModel)]="entryForm.meeting.actions" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
      </section>

      <section class="panel" *ngIf="selectedEntryType === 'DECISION'">
        <header>
          <h3>Decisao</h3>
        </header>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Decisao tomada</mat-label>
          <textarea matInput rows="2" [(ngModel)]="entryForm.decision.text" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Responsaveis</mat-label>
            <mat-select multiple name="decisionResponsibles" [(ngModel)]="entryForm.decision.responsibles" [disabled]="entryReadOnly">
              <mat-option *ngFor="let user of tenantUsers" [value]="user.id">{{ user.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Prazo</mat-label>
            <input matInput type="date" [(ngModel)]="entryForm.decision.dueAt" [disabled]="entryReadOnly">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Impacto esperado</mat-label>
          <textarea matInput rows="2" [(ngModel)]="entryForm.decision.impact" [disabled]="entryReadOnly"></textarea>
        </mat-form-field>
      </section>
    </div>

    <aside class="entry-side">
      <section class="panel" *ngIf="entryIsPublic">
        <header>
          <h3>Visualizadores</h3>
        </header>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Visualizadores {{ tenantName ? '(' + tenantName + ')' : '' }}</mat-label>
          <mat-chip-grid #viewersGrid aria-label="Visualizadores selecionados">
            <mat-chip-row *ngFor="let user of selectedViewerUsers" (removed)="removeViewer(user.id)">
              {{ participantChipLabel(user) }}
              <button matChipRemove aria-label="Remover visualizador" *ngIf="!entryReadOnly">
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip-row>
            <input
              matInput
              placeholder="Digite para buscar"
              [matChipInputFor]="viewersGrid"
              [matChipInputAddOnBlur]="false"
              [matAutocomplete]="viewersAuto"
              [(ngModel)]="viewersInputValue"
              #viewersInput
              (keydown.enter)="$event.preventDefault()"
              [disabled]="entryReadOnly"
            >
          </mat-chip-grid>
          <mat-autocomplete #viewersAuto="matAutocomplete" (optionSelected)="selectViewer($event.option.value)">
            <mat-option *ngIf="tenantUsersLoading" disabled>Carregando usuarios...</mat-option>
            <mat-option *ngIf="!tenantUsersLoading && !tenantUsers.length" disabled>Nenhum usuario encontrado</mat-option>
            <mat-option *ngFor="let user of filteredViewerUsers" [value]="user.id">
              {{ user.label || user.name || user.email || user.username || 'Usuario' }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </section>

      <section class="panel">
        <header>
          <h3>Evidencias</h3>
        </header>
        <div
          class="dropzone full"
          [class.dragging]="draggingEntryFiles"
          (dragover)="entryReadOnly ? $event.preventDefault() : onEntryDragOver($event)"
          (dragleave)="onEntryDragLeave()"
          (drop)="entryReadOnly ? $event.preventDefault() : onEntryDrop($event)"
          (click)="entryReadOnly ? null : entryAttachmentInput.click()"
        >
          <input type="file" #entryAttachmentInput (change)="entryReadOnly ? null : onEntryFileSelect($event)" [disabled]="entryReadOnly" multiple>
          <div class="dropzone-content">
            <mat-icon>attach_file</mat-icon>
            <div>
              <strong>Adicionar anexos</strong>
              <span>Arraste e solte aqui ou clique para selecionar</span>
            </div>
          </div>
        </div>
        <mat-progress-bar *ngIf="draggingEntryFiles" mode="indeterminate"></mat-progress-bar>
        <div class="v2-attachments" *ngIf="entryFiles.length">
          <div class="v2-attachment-card" *ngFor="let file of entryFiles; let i = index">
            <div class="file-icon">
              <mat-icon>description</mat-icon>
            </div>
            <div class="file-info">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-meta">Agora · {{ fileSizeLabel(file.size) }}</div>
            </div>
            <button mat-icon-button type="button" (click)="removeEntryFile(i)" *ngIf="!entryReadOnly">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
        <div class="v2-attachments existing" *ngIf="entryExistingAttachments.length">
          <div class="v2-attachment-card" *ngFor="let file of entryExistingAttachments">
            <div class="file-icon">
              <mat-icon>description</mat-icon>
            </div>
            <div class="file-info">
              <div class="file-name">{{ file.file_name }}</div>
              <div class="file-meta">{{ file.uploaded_at | date:'short' }} · {{ fileSizeLabel(file.file_size || 0) }}</div>
            </div>
            <a mat-icon-button [href]="attachmentUrl(file)" target="_blank">
              <mat-icon>open_in_new</mat-icon>
            </a>
          </div>
        </div>
      </section>
    </aside>
  </div>

  <footer class="entry-footer">
    <button mat-stroked-button type="button" (click)="closeNewEntry()">Cancelar</button>
    <button mat-raised-button color="primary" type="button" [disabled]="savingEntry || !entryForm.title.trim()" (click)="saveEntry()" *ngIf="!entryReadOnly">
      {{ savingEntry ? 'Salvando...' : (isEditingEntry ? 'Salvar alteracoes' : 'Salvar no Diario') }}
    </button>
  </footer>
</section>
